export const visit = (vm, at) => {
at({ "ca-es": { "conversations-visitor-experience-components": { "emailCapture": { "failedToPublish": "No hem pogut verificar la teva adre\xE7a electr\xF2nica." } } } });
};